module.exports = __webpack_public_path__ + "static/media/banner-2.e00663eb.jpeg";